import { useLocation } from "react-router-dom";
import { qs } from "@devowl-wp/utils";
/**
 * Allows to parse query arguments from the `react-router` string.
 */ function useLocationQuery() {
    return qs.parse(useLocation().search);
}
export { useLocationQuery };
